import { PublicRoutes } from '../../../enums';

export abstract class NgxAimSettingsClass {
  routes = PublicRoutes;
}
